module.exports = "mutation UpdateSimpleGratuity($simpleGratuity:UpdateSimpleGratuityInput!){updateSimpleGratuity(simpleGratuity:$simpleGratuity){success}}"